import ApartmentGallery from '../frontend/apartment_gallery';
import ApartmentInfo from '../frontend/apartment_info';
import ApartmentCarousel from '../frontend/apartment_carousel';
import ApartmentCarouselThumbnails from '../frontend/apartment_carousel_thumbnails';

const Frontend = {
  ApartmentCarousel,
  ApartmentGallery,
  ApartmentInfo,
  ApartmentCarouselThumbnails,
};

window.Frontend = Frontend;
